/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { environment } from './environment';

export const envIs = {
  LOCALHOST: environment.ENV_NAME === 'LOCALHOST',
  DEV: environment.ENV_NAME === 'DEV',
  STAGING: environment.ENV_NAME === 'STAGING',
  PRODUCTION: environment.ENV_NAME === 'PRODUCTION',
};
